<template>
  <div class="home">
    <!-- 品牌主标题：视觉隐藏，供搜索引擎识别站点品牌 -->
    <h1 class="home__brand-h1">橘子漫嘎</h1>
    <HomeBanner />

    <div class="comic-section" v-if="categories && categories.length > 0">
      <template
        v-for="category in categories"
        :key="category?.themeBigCode"
      >
        <div
          v-if="category && category.infoVoArray && category.infoVoArray.length > 0"
          class="comic-category"
        >
          <div class="category-header">
            <h3 class="category-title">{{ category.themeBigName }}</h3>
            <button
              class="view-more-button"
              @click="goToCategory(category)"
              title="查看更多"
            >
              <AppIcon name="chevronRight" size="sm" class="view-more-icon" aria-label="查看更多" />
            </button>
          </div>
          <div class="comics-grid">
            <div
              v-for="comic in category.infoVoArray"
              :key="comic?.id"
              class="comic-card"
              @click="goToDetail(comic.id)"
            >
              <ComicCover :cover="comic.cover" :name="comic.name" />
              <div class="comic-info">
                <div class="comic-name-author">
                  <span class="comic-name">{{ comic.name }}</span>
                  <span class="comic-author">— {{ comic.authorName }}</span>
                </div>
                <div class="comic-themes">
                  <span
                    v-for="theme in comic.comicThemeArray"
                    :key="theme?.themeCode"
                    class="comic-theme"
                  >
                    {{ theme.themeName }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import HomeBanner from '@/features/home/components/HomeBanner.vue'
import { useHomePage } from '@/features/home/composables/useHomePage'
import ComicCover from '@/shared/components/ComicCover.vue'
import AppIcon from '@/shared/components/AppIcon.vue'

const {
  categories,
  goToDetail,
  goToCategory,
} = useHomePage()
</script>

<style scoped src="@/features/home/styles/Home.css"></style>
<style scoped src="@/features/home/styles/HomeComics.css"></style>
